import React from 'react';
import './SportsDevelopment.css';

const SportsDevelopment = () => {
  return (
    <section className="sports-development">
      <div className="sports-development-wrapper">
        <h2 className="sports-development-section-title">Sports Development</h2>
        <div className="sports-development-grid">
          <div className="sports-development-card">
            <h3>Football</h3>
            <p>Training and tournaments for aspiring football players.</p>
          </div>
          <div className="sports-development-card">
            <h3>Basketball</h3>
            <p>Building skills and promoting basketball culture.</p>
          </div>
          <div className="sports-development-card">
            <h3>Athletics</h3>
            <p>Supporting track and field athletes in the region.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SportsDevelopment;